import { useState } from 'react'

/**
 * CopyCell — renders a monospace tracking/shipment number with a
 * copy-to-clipboard icon that appears on hover.
 *
 * Use inside a <td> or anywhere inline:
 *   <td><CopyCell value={row.tracking_number} /></td>
 *   <CopyCell value={ship.tracking_number} />
 */
export function CopyCell({ value }: { value: string | null | undefined }) {
  const [copied, setCopied] = useState(false)

  if (!value) return <span className="text-ink-400">—</span>

  function copy(e: React.MouseEvent) {
    e.stopPropagation()
    navigator.clipboard.writeText(value!).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    })
  }

  return (
    <span className="group/copy inline-flex items-center gap-1 font-mono text-[11px] text-ink-600">
      <span className="truncate max-w-[160px]" title={value}>{value}</span>
      <button
        onClick={copy}
        className="opacity-0 group-hover/copy:opacity-100 transition-opacity shrink-0 text-ink-400 hover:text-ink-700"
        title="Copy"
        type="button"
      >
        {copied ? (
          <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3 text-mint-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="9" y="9" width="13" height="13" rx="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
        )}
      </button>
    </span>
  )
}
